import _ from "lodash/lodash";
import Moment from "moment/moment";
import UUID from "../../../core/util/uuid";
import Booking from "../../model/booking.model";
import {BookingsFilter} from "../../services/bookings.service";
import BookingActions from "./bookings.actions.html";
import DayCalendar from "../../components/calendar/model/day-calendar.model";
import WeekCalendar from "../../components/calendar/model/week-calendar.model";
import MonthCalendar from "../../components/calendar/model/month-calendar.model";
import CalendarItem from "../../components/calendar/model/calendar-item.model";
import BookingDetailsCtrl from "../../views/booking-details/booking-details.controller";

export default class BookingsCtrl extends BookingDetailsCtrl {
    static $inject = _(BookingDetailsCtrl.$inject).union(
        ['$scope', '$state', '$ionicPopover', '$ionicPosition', '$ionicScrollDelegate', 'Bookings', 'Resources', 'settings', 'searchModalDelegate', 'screenSize']).value();

    constructor() {
        super(...arguments);

        this.actionsPopover = null;
        this.selectedDate = Moment();
        this.dateStart = null;
        this.dateEnd = null;

        this.viewTitle = null;
        this.viewMode = 'day';
        this.listMode = true;
        this.groupType = 'active';

        this.bookingsFilter = new BookingsFilter();
        this.resources = [];
        this.bookings = [];
        this.groupedBookings = [];
        this.dayCalendar = new DayCalendar();
        this.weekCalendar = new WeekCalendar();
        this.monthCalendar = new MonthCalendar();
        this.booking = null;
        this.monthDayBookings = [];

        this.scrollPositions = {};
        this.scrollLeftDelegate = null;
        this.scrollRightDelegate = null;
    }

    $onViewBeforeEnter() {
        this.booking = null;
        this.scrollLeftDelegate = this.$ionicScrollDelegate.$getByHandle('splitViewLeftScroll');
        this.scrollRightDelegate = this.$ionicScrollDelegate.$getByHandle('splitViewRightScroll');

        if (this.bookings.length == 0) {
            this.onDateSelected(Moment());
        } else {
            this.loadBookings();
        }

        this.Resources.all().then((resources) => {
            this.resources = resources;
        });
    }

    $onDestroy() {
        if (this.actionsPopover) {
            this.actionsPopover.remove();
        }
    }

    loadBookings() {
        this.bookingsFilter.max = null;
        this.bookingsFilter.dateStart = Moment(this.selectedDate).startOf(this.viewMode);
        this.bookingsFilter.dateEnd = Moment(this.selectedDate).endOf(this.viewMode);
        this.bookingsFilter.branchId = this.settings.branch.id;
        this.bookingsFilter.state = this.settings.calendarOnlyOpenBookings ? 'open' : null;

        return this.Bookings.find(this.bookingsFilter).then((result) => {
                this.bookings = result.data;

                if (this.settings.calendarOnlyOpenBookings) {
                    this.bookings = this.bookings.filter(booking => booking.isOpen());
                }

                this.groupBookings();
                this.updateCalenders();

                if (this.listMode || this.groupType != 'time') {
                    this.scrollLeftDelegate.resize();
                    this.scrollLeftDelegate.scrollTop();
                }
            }
        );
    }

    updateCalenders() {
        let items = this.bookings.map((booking) => {
            return new CalendarItem({
                id: booking.id,
                start: booking.startTime,
                end: booking.endTime,
                title: booking.title,
                color: booking.backgroundColor,
                data: booking
            });
        });

        this.dayCalendar.withSunday
            = this.weekCalendar.withSunday
            = this.monthCalendar.withSunday
            = this.settings.calendarWithSunday;

        this.dayCalendar.date
            = this.weekCalendar.date
            = this.monthCalendar.date
            = this.selectedDate;

        this.dayCalendar.items
            = this.weekCalendar.items
            = this.monthCalendar.items
            = items;

        this.dayCalendar.firstHour
            = this.weekCalendar.firstHour
            = this.settings.calendarFirstHour;

        this.dayCalendar.lastHour
            = this.weekCalendar.lastHour
            = this.settings.calendarLastHour;
    }

    groupBookings() {
        if (this.groupType == 'active') {
            this.groupByActive();

        } else if (this.groupType == 'time') {
            this.groupByTime();

        } else if (this.groupType == 'resource') {
            this.groupByResource();

        } else if (this.groupType == 'service') {
            this.groupByService();
        }
    }

    groupByActive(orByTimeIfEmpty) {
        if (orByTimeIfEmpty == null) {
            orByTimeIfEmpty = true;
        }

        this.groupType = 'active';
        this.groupedBookings = Booking.groupByActive(this.bookings, 5);

        if (this.groupedBookings[0].bookings.length == 0
            && this.bookings.length > 0
            && orByTimeIfEmpty) {

            this.groupByTime();
        }
    };

    groupByTime() {
        this.saveScrollPosition();
        this.groupType = 'time';

        if (this.viewMode == 'day') {
            this.groupedBookings = Booking.groupByHour(this.bookings);
        } else {
            this.groupedBookings = Booking.groupByDay(this.bookings);
        }

        this.loadScrollPosition();
    };

    groupByResource() {
        this.saveScrollPosition();
        this.groupType = 'resource';
        this.groupedBookings = Booking.groupByResource(this.bookings);

        let resourcesWithoutBookings = this.resources.filter((resource) => {
            let group = this.groupedBookings.find(group => group.title == resource.name);
            return group == null;
        });

        resourcesWithoutBookings.forEach((resource) => {
            this.groupedBookings.push({
                id: UUID(),
                type: 'resource',
                title: resource.name,
                bookings: []
            });
        });

        this.groupedBookings = _(this.groupedBookings)
            .sortBy(group => group.title)
            .value();

        this.loadScrollPosition();
    };

    groupByService() {
        this.saveScrollPosition();
        this.groupType = 'service';

        this.groupedBookings = Booking.groupByService(this.bookings);
        this.loadScrollPosition();
    }

    prevDate() {
        this.$scope.$broadcast('weekDateSelection.prevDate');
    }

    nextDate() {
        this.$scope.$broadcast('weekDateSelection.nextDate');
    }

    onDateSelected(date) {
        this.booking = null;
        this.groupedBookings = [];
        this.selectedDate = date;
        this.updateViewTitle(date);
        this.loadBookings();
    }

    onRangeSelected(dates) {
        this.updateViewTitle(dates[2]);
    }

    selectCalendarMonthDay(date) {
        if (this.isSplitViewRightOpen()) {
            let dayBookings = _(this.bookings).filter(booking => {
                return date.isSame(Moment(booking.startTime), 'day');
            });

            this.monthDayBookings = Booking.groupByDay(dayBookings);
            this.booking = null;

        } else {
            this.viewMode = 'day';
            this.onDateSelected(date);
        }
    }

    setCurrentDate() {
        this.onDateSelected(Moment());
    }

    isCurrentDate(){
        return this.selectedDate.isSame(Moment(), 'day');
    }

    setViewMode(viewMode){
        this.viewMode = viewMode;
        this.booking = null;
        this.monthDayBookings = [];

        this.loadBookings();
    }

    openSearch(){
        this.searchModalDelegate.show({
            showTypeSelection: false,
            searchType: "bookings",
            searchWithoutTerm: false,

            onBookingSelected: (booking) => {
                this.openBooking(booking);
            }
        })
    }

    toggleListMode() {
        this.saveScrollPosition();
        this.listMode = !this.listMode;
        this.monthDayBookings = [];
        this.loadScrollPosition();
    }

    updateViewTitle(date) {
        date = Moment(date);

        if (this.viewMode == 'day') {
            this.viewTitle = date.format('MMMM, [KW] WW');

        } else if (this.viewMode == 'week') {
            this.viewTitle = date.format('MMMM');

        } else if (this.viewMode == 'month') {
            this.viewTitle = date.format('YYYY');
        }
    }

    onBookingUpdated() {
        // Recreate groupings and update calendars
        // to update the UI elements.
        this.groupBookings();
        this.updateCalenders();
    }

    openBookingDetails(booking) {
        this.openBooking(booking, true);
    }

    openBooking(booking, openDetailsView) {
        openDetailsView = openDetailsView || !this.isSplitViewRightOpen();

        if (openDetailsView) {
            this.$state.go('tab.booking-details', {bookingId: booking.id});
        } else {
            this.booking = booking;
            this.scrollRightDelegate.scrollTop();
        }
    }

    isSplitViewRightOpen() {
        return this.screenSize.is('md,lg') || this.settings.calendarForceSplitView;
    }

    saveScrollPosition() {
        var scrollPos = this.scrollLeftDelegate.getScrollPosition();
        this.scrollPositions[this.scrollKey()] = scrollPos;
    }

    loadScrollPosition() {
        var scrollPos = this.scrollPositions[this.scrollKey()];
        if (scrollPos) {
            this.scrollLeftDelegate.scrollTo(scrollPos.left, scrollPos.top, false);
        } else {
            var top = 0;

            if (!this.listMode) {
                top = Moment().hour() * 60 - 60;
                if (top < 0) {
                    top = 0;
                }
            }

            this.$ionicScrollDelegate.scrollTo(0, top, true);
        }
    }

    scrollKey() {
        var scrollKey = this.groupType;
        if (this.groupType == 'time') {
            scrollKey += this.listMode ? '-list' : '-calendar';
        }

        return scrollKey;
    }

    showActions($event) {
        if (!this.actionsPopover) {
            this.actionsPopover = this.$ionicPopover.fromTemplate(BookingActions, {
                scope: this.$scope
            });
        }

        this.actionsPopover.show($event);
    }

    actionSetCurrentDate() {
        this.actionsPopover.hide();
        this.setCurrentDate();
    }

    actionOpenSearch() {
        this.actionsPopover.hide().then(() => {
           this.openSearch();
        });
    }

    actionSetViewMode(viewMode) {
        this.actionsPopover.hide();
        this.setViewMode(viewMode);
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/views/bookings/bookings.controller.js